<template>
<main class="content-body">
  <header class="page-header">
    <h2>Zone A</h2>
  </header>
  <div class="row">
    <div class="col-md-12 col-lg-12 col-xl-12">
      <section class="panel">
        <header class="panel-heading">
          <h2 class="panel-title" style="display:inline">Billets</h2>
          <div style="float:right">
              <router-link :to="{name:'billet_creation'}" class="btn btn-primary"><i class="fa fa-plus"></i> Créer un billet</router-link>
            </div>
        </header>

        <div class="panel-body">
          <div class="row">
            <div class="col-xl-12 mb-md">

              <label  style="float:left;margin-right:10px;">
                <input style='max-width:150px;display:inline;' v-bind:value="keywords" v-on:input="debounceSearch($event.target.value)" class="form-control" placeholder="Recherche" aria-controls="listing-datatable">
              </label>
              <label style="float:left;margin-right:10px;">
                <select v-model="type_key" class="form-control" v-on:change="loadStatus">
                  <option disabled value="">Type</option>
                  <option value="">Tous</option>
                  <option v-for="option in ticket_type_option" v-bind:value="option.ticket_type_key"
                    :key="option.ticket_type_key">
                    {{ option.name }}
                  </option>
                </select>
              </label>
              <label style="float:left;margin-right:10px;" v-show="showStatus">
                <select v-model="status" class="form-control" style='max-width:100px' v-on:change="newStart">
                  <option disabled value="">Statut</option>
                  <option value="">Tous</option>
                  <option v-for="option in status_option"
                    :value="option.status_id" :key="option.status_id">
                    {{ option.status_name}}
                  </option>
                </select>
              </label>

              <label style="float:left;margin-right:10px;">
                <select v-model="service_provider_id" class="form-control" v-on:change="newStart" style="max-width:150px">
                  <option disabled value="">Fournisseur</option>
                  <option value="">Tous</option>
                  <option v-for="option in service_provider_option"
                    v-bind:value="option.service_provider_id"
                    :key="option.service_provider_id">
                      {{ option.service_provider_name }}
                    </option>
                </select>
              </label>
              <label style="float:left;margin-right:10px;">
                <select v-model="requirement" class="form-control" v-on:change="newStart" style='max-width:150px'>
                  <option disabled value="">Exigence</option>
                  <option value="">Tous</option>
                  <option v-for="option in requirement_option" v-bind:value="option.requirement_id"
                    :key="option.requirement_id">
                    {{ option.name }}
                  </option>
                </select>
              </label>
              <label style="float:left;margin-right:10px;">
                <select v-model="responsable" v-on:change="newStart" class="form-control" style='max-width:150px'>
                  <option disabled value="">Responsable</option>
                  <option value="">Tous</option>
                  <option v-for="option in responsable_option"
                    :value="option.user_id" :key="option.user_id">
                    {{ option.responsable_name }}
                  </option>
                </select>
              </label>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 col-lg-12 col-xl-12 text-right">
              <Pagination
              :pageSize.sync="pageSize"
              :sizeOptions="sizeOptions"
              :selectedPageNum="pageNum"
              :totalRecords="totalRecords"
              v-on:change-page="changePage"
              :limit="2"
              :isLoading="isLoading"
              :disable="isLoading"
              >
              </Pagination>
            </div>
          </div>

          <div class="table-responsive">
            <div class="table-responsive">
              <GridGeneral
              :data="tickets"
              :columns="gridColumns"
              :sortColumns="gridColumnsSort"
              :loadData="refresh">
              </GridGeneral>
            </div>

          </div>

          <div class="row">
            <div class="col-md-12 col-lg-12 col-xl-12 text-right">
              <Pagination
              :pageSize.sync="pageSize"
              :sizeOptions="sizeOptions"
              :selectedPageNum="pageNum"
              :totalRecords="totalRecords"
              v-on:change-page="changePage"
              :limit="2"
              :isLoading="isLoading"
              :disable="isLoading"
              >
              </Pagination>
            </div>
          </div>
          
        </div>

      </section>
    </div>
  </div>
</main>
</template>
<script>

import axios from 'axios';
import GridGeneral from '@/components/GridGeneral.vue'
import Pagination from '@/components/Pagination.vue'

function scrollToTop(){
  window.setTimeout(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, 200);
}

export default {
  data: function() {return {
    keywords:'',
    tickets: {},
    type_key: '',
    type_resolution: '',
    title:'',
    ticket_type_option: {},
    responsable_option: {},
    requirement_option: {},
    service_provider_option: {},
    status_option: {},
    sort:'',
    sortOrder:1,
    service_provider_id:'',
    requirement:'',
    responsable:'',
    status:'',
    showStatus:false,
    gridColumns: [
      {field:'element_id',title:'Clé'},
      {field:'type',title:'Type'},
      {field:'title',title:'Titre'},
      {field:'service_provider',title:'Fournisseur'},
      {field:'requirement',title:'Exigence'},
      {field:'responsable',title:'Reponsable'},
      {field:'status',title:'Statut'}
    ],
    gridColumnsSort : ['type','title','service_provider','requirement','responsable','status'],
    pageSize: 50,
    sizeOptions: [20, 50, 100],
    pageNum: 1,
    totalRecords: 0,
    isLoading: false,
    preventRefresh: false
  }},

  name: 'TicketList',
  components: {
    GridGeneral,
    Pagination
  },
  methods: {

    debounceSearch: function(val){
      this.keywords = val;
      if(this.search_timeout) clearTimeout(this.search_timeout);
      
      const self = this;
      this.search_timeout = setTimeout(function() {
        self.refresh();
      }, 200);
    },

    newStart: function () {
      this.refresh();
      this.loadFilters();
    },

    loadFilters: function() {
      axios
        .get(this.$root.$data.server_base + '/api/ticket_filter_dropdown.php',
          { })
        .then(response => {
          this.ticket_type_option = response.data.ticket_type;
          this.responsable_option = response.data.responsable;
          this.service_provider_option = response.data.service_provider;
          this.requirement_option = response.data.requirement;
        })
    },

    loadStatus: function()
    {
      axios
        .get(this.$root.$data.server_base + '/api/ticket_creation_dropdown_status.php',
          { params:{ticket_type_key:this.type_key}})
        .then(response => (this.status_option = response.data.ticket_status,
          ((this.type_key != '')? this.showStatus=true : (this.showStatus=false)),
          this.status='',this.refresh()))

    },

    changePage: function(pageNum)
    {
      this.pageNum = pageNum
    },

    prepareUrlHashToSet: function() {
      return `page=${this.pageNum}&pageSize=${this.pageSize}`
    },

    readPaginationFromUrlHashAndRefresh: function() {
      this.preventRefresh = true;
      this.$nextTick(() => {
        this.setSelectedPageNumFromUrlHash()
        this.setSelectedPageSizeFromUrlHash()
        this.preventRefresh = false;
        this.refresh();
      })
    },

    setSelectedPageNumFromUrlHash: function() {
      var pageNumFromUrlHash = getHashParameterByName('page')
      if (!pageNumFromUrlHash || pageNumFromUrlHash === '') {
        return
      }
      this.pageNum = pageNumFromUrlHash
    },

    setSelectedPageSizeFromUrlHash: function() {
      var pageSizeFromUrlHash = getHashParameterByName('pageSize')
      if (!pageSizeFromUrlHash || pageSizeFromUrlHash === '') {
        return
      }
      this.pageSize = pageSizeFromUrlHash
    },

    refresh: function() {
      if (this.preventRefresh === true) return
      this.isLoading = true
      axios
        .get(this.$root.$data.server_base + '/api/tickets.php',
          { params: {
            sort:this.sort,
            sortOrder:this.sortOrder,
            type_key: this.type_key,
            ticket_resolution: this.ticket_resolution,
            status:this.status,
            service_provider_id:this.service_provider_id,
            requirement:this.requirement,
            responsable:this.responsable,
            keywords:this.keywords,
            page:this.pageNum,
            page_size:this.pageSize
          }})
        .then(response => {
          this.$checkApiErrors(response.data);
          this.tickets = response.data.tickets;
          this.pageNum = response.data.page_num;
          this.totalRecords = response.data.total;
          this.isLoading = false
          scrollToTop()
        })
    },
  },
  watch: {
    $route() {
      this.service_provider_id=this.$route.query.service_provider_id || '';
      this.type_key=this.$route.query.type_key || '';
      this.ticket_resolution=this.$route.query.ticket_resolution || '';
      this.refresh();
      this.loadFilters();
    },
    pageNum(newVal, oldVal) {
      if (+newVal !== +oldVal) {
        this.refresh();
        replaceUrlHash(this.prepareUrlHashToSet())
      }
    },
    pageSize(newVal, oldVal) {
      if (+newVal !== +oldVal) {
        this.refresh();
        replaceUrlHash(this.prepareUrlHashToSet())
      }
    }
  },
  mounted () {
    this.service_provider_id=this.$route.query.service_provider_id || '';
    this.type_key=this.$route.query.type_key || '';
    this.ticket_resolution=this.$route.query.ticket_resolution || '';
    this.responsable=this.$route.query.responsable || '';
    this.readPaginationFromUrlHashAndRefresh();
    this.loadFilters();
  }
}

function replaceUrlHash(newHash) {
  if ((''+newHash).charAt(0) !== '#') newHash = '#' + newHash;
  history.replaceState('', '', newHash);
}

// https://stackoverflow.com/a/901144/2414273
function getHashParameterByName(name, hash) {
  if (!hash) hash = window.location.hash;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[#&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(hash);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
</script>
